export const ADD_TO_CART = "ADD_TO_CART";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const REMOVE_CART = "REMOVE_CART";
export const EDIT_ITEM_CART = "EDIT_ITEM_CART";
export const TEBUS_MURAH_ADD_TO_CART = "TEBUS_MURAH_ADD_TO_CART";
export const TEBUS_MURAH_DELETE_FROM_CART = "TEBUS_MURAH_DELETE_FROM_CART";
export const XY_DELETE_FROM_CART = "XY_DELETE_FROM_CART";
export const XY_ADD_TO_CART = "XY_ADD_FROM_CART";

//add to cart
export const addToCart = (item) => {
  return (dispatch) => {
    dispatch({
      type: ADD_TO_CART,
      payload: {
        ...item,
        selectedProductColor: null,
        selectedProductSize: null,
      },
    });
  };
};

export const addToCartXY = (item) => {
  return (dispatch) => {
    dispatch({
      type: XY_ADD_TO_CART,
      payload: {
        ...item,
        selectedProductColor: null,
        selectedProductSize: null,
      },
    });
  };
};

//add to cart tebus murah
export const addToCartTebusMurah = (item) => {
  // const tebusMurah = await getData()
  if(item !== undefined){
    return (dispatch) => {
      dispatch({
        type: TEBUS_MURAH_ADD_TO_CART,
        payload: {
          ...item,
          selectedProductColor: null,
          selectedProductSize: null,
        },
      });
    };
  }
};
// save edit item cart
export const editItemCart = (item) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_ITEM_CART,
      payload: {
        ...item,
        selectedProductColor: null,
        selectedProductSize: null,
      },
    });
  };
};
//decrease from cart
export const decreaseQuantity = (item, addToast) => {
  return (dispatch) => {
    if (addToast) {
      addToast("Item Decremented From Cart", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
    dispatch({ type: DECREASE_QUANTITY, payload: item });
  };
};
//increase from cart
export const increaseQuantity = (item, addToast) => {
  return (dispatch) => {
    if (addToast) {
      addToast("Item Increased From Cart", {
        appearance: "warning",
        autoDismiss: true,
      });
    }
    dispatch({ type: INCREASE_QUANTITY, payload: item });
  };
};
//delete from cart
export const deleteFromCartTebusMurah = (item, addToast) => {
  return (dispatch) => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: TEBUS_MURAH_DELETE_FROM_CART, payload: item });
  };
};

export const deleteFromCartXY = (item, addToast) => {
  return (dispatch) => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: XY_DELETE_FROM_CART, payload: item });
  };
};

//tebus murah delete from cart
export const deleteFromCart = (item, addToast) => {
  return (dispatch) => {
    if (addToast) {
      addToast("Removed From Cart", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: DELETE_FROM_CART, payload: item });
  };
};
//delete all from cart
export const deleteAllFromCart = (addToast) => {
  return (dispatch) => {
    // if (addToast) {
    //   addToast("Removed All From Cart", {
    //     appearance: "error",
    //     autoDismiss: true,
    //   });
    // }
    dispatch({ type: REMOVE_CART });
  };
};

// get stock of cart item
export const cartItemStock = (item, color, size) => {
  if (item.stock) {
    return item.stock;
  } else {
    return item.variation
      .filter((single) => single.color === color)[0]
      .size.filter((single) => single.name === size)[0].stock;
  }
};
